import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Stepper } from 'legion-ui';
import StepperExample from './StepperExample.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`A stepper component to display step by step user action.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Stepper } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Basic`}</strong></h3>
    <p>{`Default usage of Stepper with its first step being in Step 1, and has description in its first state.`}</p>
    <div className="wrapper-display-component-three">
  <div className="item-three">
    <StepperExample mdxType="StepperExample" />
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react';
import { Button, Stepper } from 'legion-ui';
export default function StepperExample() {
  const [currentStep, setCurrentStep] = React.useState(0);
  const handleNext = () => {
    if (currentStep !== steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };
  const handlePrev = () => {
    if (currentStep !== 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const steps = [
    {
      label: {
        title:"Step 1",
        description: "Desc"
      }
    },
    {
      label: {
        title:"Step 2"
      }
    }, 
    {
      label: {
        title:"Step 3"
      }
    }, 
    {
      label: {
        title:"Step 4"
      },
      icon: 'Check'
    }
  ];
  return (
    <React.Fragment>
      <Stepper 
        steps={steps}
        currentStep={currentStep}
        orientation="vertical"
        borderColor="green"
        backgroundColor="green"
        showBoxShadow={true}
        showTextOn="right"
        variant="warning" 
      />
      <div style={{ display: "flex", marginTop: '1rem' }}>
        <Button onClick={handlePrev} style={{ marginRight: '.5rem' }}>Prev</Button>
        <Button onClick={handleNext}>Next</Button>
      </div>
    </React.Fragment>
  );
};
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`backgroundColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The background color of each stepper items`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The border color of each stepper items`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`currentStep`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets in which step is the stepper currently in`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`orientation`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`horizontal`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`vertical`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`horizontal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the default orientation (top to bottom or left to right) of the stepper`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showTextOn`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`right`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`bottom`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`right`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets in which direction from the stepper, would the text be rendered`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`variant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`success`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`warning`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`success`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets which variant of stepper would like to be rendered`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Steps`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`steps`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Main props should be given to the Stepper component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`✓`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the title of each stepper items, `}<strong parentName="td">{`should be inside label object`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`description`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets complementary description of each stepper items, `}<strong parentName="td">{`should be inside label object`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`icon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`IconName from `}<a parentName="td" {...{
              "href": "https://feathericons.com/"
            }}>{`react-feather`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Give the stepper item an icon, `}<strong parentName="td">{`should be inside steps array`}</strong>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      